import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'jsx/elements/inputs/Checkbox';

const DefaultRegistryFilter = ({ onChange, filterValues, t }) => {
  return (
    <div className="form">
      <Checkbox
        name="sevGroup3"
        id="sevGroup3"
        value={filterValues.sevGroup3}
        label={t('portfolio_filters_defaultRegistry_group3')}
        onChange={onChange}
      />
      <Checkbox
        name="sevGroup2"
        id="sevGroup2"
        value={filterValues.sevGroup2}
        label={t('portfolio_filters_defaultRegistry_group2')}
        onChange={onChange}
      />
      <Checkbox
        name="sevGroup1"
        id="sevGroup1"
        value={filterValues.sevGroup1}
        label={t('portfolio_filters_defaultRegistry_group1')}
        onChange={onChange}
      />
      <Checkbox
        name="sevGroupOther"
        id="sevGroupOther"
        value={filterValues.sevGroupOther}
        label={t('portfolio_filters_defaultRegistry_groupOther')}
        onChange={onChange}
      />
      <Checkbox
        name="notOnDDRegistry"
        id="notOnDDRegistry"
        value={filterValues.notOnDDRegistry}
        label={t('portfolio_filters_defaultRegistry_notOnDDRegistry')}
        onChange={onChange}
      />
    </div>
  );
};

DefaultRegistryFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  filterValues: PropTypes.object.isRequired
};

export default DefaultRegistryFilter;
